import { Download, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { corporateProfile, cvUrl, rateCardUrl } from "@/data/eventOrganizerContent";

const CorporateProfileSection = () => {
  return (
    <section id="corporate-profile" data-testid="corporate-profile-section" className="space-y-10 py-24">
      <div className="max-w-4xl space-y-4">
        <p
          data-testid="corporate-profile-eyebrow-text"
          className="inline-flex items-center gap-2 rounded-full border border-fuchsia-200 bg-fuchsia-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.16em] text-fuchsia-700"
        >
          <FileText className="h-3.5 w-3.5" />
          {corporateProfile.heading}
        </p>
        <h2 data-testid="corporate-profile-heading" className="text-3xl leading-tight text-violet-950 md:text-5xl">
          Professional profile and credentials for corporate decision-makers.
        </h2>
        <p data-testid="corporate-profile-subtitle" className="text-sm text-stone-600 md:text-base">
          {corporateProfile.subtitle}
        </p>
      </div>

      <Card data-testid="corporate-profile-card" className="border-fuchsia-200 bg-violet-50/75">
        <CardContent className="space-y-6 p-7">
          <div className="grid gap-3 md:grid-cols-2">
            {corporateProfile.profileHighlights.map((item, index) => (
              <div
                key={item}
                data-testid={`corporate-profile-highlight-${index + 1}`}
                className="rounded-xl border border-fuchsia-200 bg-fuchsia-100/65 px-4 py-3 text-sm text-violet-900"
              >
                {item}
              </div>
            ))}
          </div>

          <div className="flex flex-wrap gap-3">
            <Button
              asChild
              className="h-11 rounded-full bg-fuchsia-700 px-6 text-xs font-semibold uppercase tracking-[0.13em] text-white hover:bg-fuchsia-800"
              data-testid="corporate-profile-download-cv-button"
            >
              <a href={cvUrl} target="_blank" rel="noreferrer" aria-label="Download Rebecca CV">
                <Download className="h-4 w-4" />
                Download CV (PDF)
              </a>
            </Button>

            <Button
              asChild
              variant="outline"
              className="h-11 rounded-full border-fuchsia-300 bg-white px-6 text-xs font-semibold uppercase tracking-[0.13em] text-fuchsia-800 hover:bg-fuchsia-50"
              data-testid="corporate-profile-download-ratecard-button"
            >
              <a href={rateCardUrl} target="_blank" rel="noreferrer" aria-label="Download rate card">
                <Download className="h-4 w-4" />
                Download Rate Card
              </a>
            </Button>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};

export default CorporateProfileSection;